export default __webpack_public_path__ + "static/media/prtbl.35629e89.png";